export default __webpack_public_path__ + "static/media/logo_tilla_white.5f57d88f.svg";